import { axiosInstance, downloadBlobDataFile } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOrdersInvoiceNumberExcelParams } from '~/types/order.types';

/**
 * [출고주문관리 > 출고주문조회] 주문 엑셀 다운로드 API
 */
const useGetOrdersInvoiceNumberExcel = () => {
  const endPoint = '/api-oms/orders/invoice-number-excel';

  const getOrdersInvoiceNumberExcel = async (params: TypeGetOrdersInvoiceNumberExcelParams) => {
    return axiosInstance
      .get(endPoint, {
        params,
        responseType: 'blob',
      })
      .then((data) => {
        downloadBlobDataFile(data);
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { getOrdersInvoiceNumberExcel };
};

export default useGetOrdersInvoiceNumberExcel;
